"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const id_1 = __importDefault(require("../EditorState/id"));
const fromRaw = (raw) => {
    const state = {
        value: []
    };
    let ignore = true;
    const text = raw.text;
    for (let char of text) {
        if (char === '[') {
            ignore = false;
            const val = {
                type: 'block-start',
                styles: [],
                blockKey: id_1.default()
            };
            state.value.push(val);
        }
        else if (char === ']') {
            ignore = true;
            const val = {
                type: 'block-end'
            };
            state.value.push(val);
        }
        else if (ignore === false) {
            const val = {
                char,
                styles: [],
            };
            state.value.push(val);
        }
    }
    raw.ranges.forEach((_a) => {
        var { offset, length } = _a, charData = __rest(_a, ["offset", "length"]);
        for (var i = offset; i < offset + length; i++) {
            const value = state.value[i];
            if ('char' in value || value.type === 'block-start') {
                const newValue = Object.assign(Object.assign({}, value), charData);
                state.value[i] = newValue;
            }
        }
    });
    return state;
};
exports.default = fromRaw;
//# sourceMappingURL=fromRaw.js.map